// extracted by mini-css-extract-plugin
export var container = "generator-layout-module--container--YB-cM";
export var content = "generator-layout-module--content--U9qQz";
export var header = "generator-layout-module--header--PwfzR";
export var paddingTop = "generator-layout-module--padding-top--V7Otb";
export var savedStylizationContainer = "generator-layout-module--saved-stylization-container--Dhhfu";
export var savedStylizationContent = "generator-layout-module--saved-stylization-content--ZBH7d";
export var savedStylizationHeader = "generator-layout-module--saved-stylization-header--C-GLG";